import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(
    private messageService: MessageService
  ) { }

  tiempoVidaNotificacion: number = 2300;


  //El campo sumary es segundo parametro ya que es opcional
  public HanddleInfoMessage(detail: string, summary: string = "Confirmado", data: any = null) {
    this.messageService.clear();
    this.messageService.add({
      key: 'toat-message',
      severity: 'info',
      summary: summary,
      detail: detail,
      data: data
    });
  }

  //El campo sumary es segundo parametro ya que es opcional
  public HanddleWarningMessage(detail: any, summary: string = "Atención", data: any = null) {
    this.messageService.clear();

    this.messageService.add({
      severity: 'warn',
      key: 'toat-message',
      summary: summary,
      detail: detail,
      data: data
    });
  }
  //El campo sumary es segundo parametro ya que es opcional
  public HanddleSuccessMessage(detail: any, summary: string = "Atención", data: any = null) {
    this.messageService.clear();

    this.messageService.add({
      severity: 'success',
      key: 'toat-message',
      summary: summary,
      detail: detail,
      data: data
    });
  }

  //El campo sumary es segundo parametro ya que es opcional
  public HanddleErrorMessage(detail: any, summary: string = "Error", life: number = 8000, data: any = null) {
    this.messageService.clear();

    this.messageService.add({
      severity: 'error',
      key: 'toat-message',
      summary: summary,
      detail: detail,
      life: life,
      data: data
    });
  }

  public  HandleDynamicNotification(notif: any) {
    console.log("🚀 ~ notif:", notif)
    // Si no viene color de BD, forzamos uno según el tipo para asegurar el fondo
    let finalColor = notif.template.color;

    if (!finalColor) {
      switch (notif.template.notification_type) {
        case 1: finalColor = '#5F5EE5'; break; // Azul (Info)
        case 2: finalColor = '#10B981'; break; // Verde (Success)
        case 3: finalColor = '#F59E0B'; break; // Naranja (Warning)
        case 4: finalColor = '#EF4444'; break; // Rojo (Error/Rechazado)
        default: finalColor = '#5F5EE5'; break;
      }
    }
    notif.color = finalColor;
    notif.icon = notif.template.icon || 'pi-info-circle'; // Ícono por defecto si no viene
    
    this.messageService.add({
      key: 'dynamic-toast',
      severity: 'custom',
      closable:false,
      summary: notif.title,
      detail: notif.description,
      data: notif, // Pasamos la data con el color procesado
      life: 6000
    });
  }

  public clearNotificaciones() {
    this.messageService.clear();
  }
}
